import React from 'react';
import { 
  Scale, 
  Info, 
  Clock,
  Shield,
  ScrollText,
  ExternalLink 
} from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-gray-100 pt-24">
      {/* Minimal Header */}
      <header className="bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center space-x-3">
            <Scale className="w-6 h-6 text-blue-500" />
            <h1 className="text-2xl font-semibold text-gray-800">Terms of Service</h1>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        {/* Last Updated Notice */}
        <div className="flex items-center text-sm text-gray-500 mb-8">
          <Clock className="w-4 h-4 mr-2" />
          Last updated: January 21, 2025
        </div>

        {/* Introduction Card */}
        <div className="bg-blue-50 border border-blue-100 rounded-xl p-6 mb-8">
          <div className="flex items-start">
            <Info className="w-5 h-5 text-blue-500 mt-1 mr-4 flex-shrink-0" />
            <p className="text-sm text-blue-700">
              Please read these Terms of Service carefully before using Gortherm's services. 
              By accessing or using our services, you agree to be bound by these terms.
            </p>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-600 leading-relaxed">
                By accessing and using Gortherm's services, you acknowledge that you have read, 
                understood, and agree to be bound by these Terms of Service. If you do not agree 
                with any part of these terms, you may not use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">2. User Accounts</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                When you create an account with us, you guarantee that the information you provide 
                is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete 
                information may result in the immediate termination of your account.
              </p>
              <p className="text-gray-600 leading-relaxed">
                You are responsible for maintaining the confidentiality of your account and password, 
                including but not limited to restricting access to your computer and/or account. You 
                agree to accept responsibility for any and all activities that occur under your account.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Service Modifications</h2>
              <p className="text-gray-600 leading-relaxed">
                Gortherm reserves the right to withdraw or modify our service, and any service or 
                material we provide, in our sole discretion without notice. We will not be liable if, 
                for any reason, all or any part of the service is unavailable at any time or for any period.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Intellectual Property</h2>
              <p className="text-gray-600 leading-relaxed">
                The service and all contents, including but not limited to text, images, graphics, 
                or code are the property of Gortherm and are protected by copyright, trademark, and 
                other intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">5. User Responsibilities</h2>
              <p className="text-gray-600 leading-relaxed">
                You agree not to misuse our services or help anyone else do so. For example, you must 
                not attempt to access our services using any method other than the interface and 
                instructions we provide.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Termination</h2>
              <p className="text-gray-600 leading-relaxed">
                We may terminate or suspend your account and bar access to the service immediately, 
                without prior notice or liability, under our sole discretion, for any reason whatsoever.
              </p>
            </section>
          </div>
        </div>

        {/* Acceptance Notice */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 mb-8">
          <div className="flex items-start">
            <ScrollText className="w-5 h-5 text-gray-500 mt-1 mr-4 flex-shrink-0" />
            <p className="text-sm text-gray-600">
              By continuing to use our services, you acknowledge that you have read, understood, 
              and agree to be bound by these Terms of Service. For any questions or concerns, 
              please contact our legal team.
            </p>
          </div>
        </div>

        {/* Simple Contact Section */}
        
      </main>

      {/* Minimal Footer */}
      
    </div>
  );
};

export default TermsOfService;